import axios from "axios"

async function buscarDadosEmpresas(params) {
    const batchGet = await _buscarDadosBatch(process.env.REACT_APP_ID_PLANILHA, ['EmpresasProdutoSustentavel', 'ProdutosProdutoSustentavel', 'VídeosProdutoSustentavel', 'Contatos', 'Imagens', 'Notícias'])

    const empresas = batchGet['EmpresasProdutoSustentavel']
    const produtos = batchGet['ProdutosProdutoSustentavel']
    const videos = batchGet['VídeosProdutoSustentavel']
    const contatos = batchGet['Contatos']
    const imagens = batchGet['Imagens']
    const noticias = batchGet['Notícias']

    // Produtos

    for (let i = 0; i < produtos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === produtos[i]['Empresa']) {

                // Se a chave de produtos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Produtos']) {
                    empresas[j]['Produtos'] = []
                }

                empresas[j]['Produtos'].push(produtos[i])
                break
            }
        }

    }

    // Vídeos
    for (let i = 0; i < videos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === videos[i]['Empresa']) {

                // Se a chave dos vídeos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Vídeos']) {
                    empresas[j]['Vídeos'] = []
                }

                empresas[j]['Vídeos'].push(videos[i])
                break
            }
        }
    }

    // Contatos
    for (let i = 0; i < contatos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === contatos[i]['Empresa']) {

                // Se a chave dos contatos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Contatos']) {
                    empresas[j]['Contatos'] = []
                }

                empresas[j]['Contatos'].push(contatos[i])
                break
            }
        }
    }

    // Imagens
    for (let i = 0; i < imagens.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === imagens[i]['Empresa'] && imagens[i]['ProdutoSustentavel']?.toUpperCase() === 'X') {

                // Se a chave das imagens ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Imagens']) {
                    empresas[j]['Imagens'] = []
                }

                empresas[j]['Imagens'].push(imagens[i])
                break
            }
        }
    }

    // Notícias
    for (let i = 0; i < noticias.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === noticias[i]['Empresa'] && noticias[i]['ProdutoSustentavel']?.toUpperCase() === 'X') {

                // Se a chave das notícias ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Notícias']) {
                    empresas[j]['Notícias'] = []
                }

                empresas[j]['Notícias'].push(noticias[i])
                break
            }
        }
    }

    return empresas
}

async function buscarDadosProdutos(params) {
    const dadosProdutos = await _buscarDados(process.env.REACT_APP_ID_PLANILHA, 'ProdutosProdutoSustentavel')
    let produtosPorEmpresa = {}
    let produtosPorEspecie = {
        'Aqua - Peixes': [],
        'Aves': [],
        'Bovinos': [],
        'Cães': [],
        'Equinos': [],
        'Gatos': [],
        'Suínos': [],
    }

    let produtosPorTema = {}
    let produtosPorCategoria = {}

    dadosProdutos.map((produto) => {
        // Incluindo na lista de produtos por empresa
        if (!produtosPorEmpresa[produto['Empresa']]) {
            produtosPorEmpresa[produto['Empresa']] = []
        }

        produtosPorEmpresa[produto['Empresa']].push(produto)

        // Incluindo na lista de produtos por espécie
        if (produto['Aves']?.toUpperCase() === 'X') {
            produtosPorEspecie['Aves'].push(produto)
        }

        if (produto['Bovinos']?.toUpperCase() === 'X') {
            produtosPorEspecie['Bovinos'].push(produto)
        }

        if (produto['Aqua - Peixes']?.toUpperCase() === 'X') {
            produtosPorEspecie['Aqua - Peixes'].push(produto)
        }

        if (produto['Cães']?.toUpperCase() === 'X') {
            produtosPorEspecie['Cães'].push(produto)
        }

        if (produto['Equinos']?.toUpperCase() === 'X') {
            produtosPorEspecie['Equinos'].push(produto)
        }

        if (produto['Gatos']?.toUpperCase() === 'X') {
            produtosPorEspecie['Gatos'].push(produto)
        }

        if (produto['Suínos']?.toUpperCase() === 'X') {
            produtosPorEspecie['Suínos'].push(produto)
        }

        // Incluindo na lista de produtos Por tema
        if (!produtosPorTema[produto['Tema']]) {
            produtosPorTema[produto['Tema']] = []
        }

        produtosPorTema[produto['Tema']].push(produto)


        // Incluindo na lista de produtos Por categoria
        // A tag <em> é utilizada na planilha para dar o efeito itálico. Vamos remover ela aqui para não ficar assim no combo de opção dos filtros.
        const categoriaProdutoTratada = produto['Categoria'].replaceAll('</em>', '').replaceAll('<em>', '')

        if (!produtosPorCategoria[categoriaProdutoTratada]) {
            produtosPorCategoria[categoriaProdutoTratada] = []
        }

        produtosPorCategoria[categoriaProdutoTratada].push(produto)
    })

    // Ordenando temas por ordem alfabética

    produtosPorTema = Object.fromEntries(Object.entries(produtosPorTema).sort())

    // Ordenando categorias por ordem alfabética

    produtosPorCategoria = Object.fromEntries(Object.entries(produtosPorCategoria).sort())

    // Deletando espécies sem produto

    for (let i = 0; i < Object.keys(produtosPorEspecie).length; i++) {
        if (produtosPorEspecie[Object.keys(produtosPorEspecie)[i]].length === 0) {
            // Deletando item e voltando um valor no i do forloop para evitar pular alguma key
            delete produtosPorEspecie[Object.keys(produtosPorEspecie)[i]]
            i--
        }
    }

    return { produtosPorEmpresa, produtosPorEspecie, produtosPorTema, produtosPorCategoria, temas: Object.keys(produtosPorTema), categorias: Object.keys(produtosPorCategoria), especies: Object.keys(produtosPorEspecie) }
}

async function buscarDadosProdutosSemSeparacaoPorEmpresa(params) {
    const batchGet = await _buscarDadosBatch(process.env.REACT_APP_ID_PLANILHA, ['ProdutosProdutoSustentavel', 'VídeosProdutos', 'Imagens', 'Notícias'])

    const dadosProdutos = batchGet['ProdutosProdutoSustentavel']
    const videos = batchGet['VídeosProdutos']
    const imagens = batchGet['Imagens']
    const noticias = batchGet['Notícias']

    // Vídeos
    for (let i = 0; i < videos.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === videos[i]['Produto/Serviço']) {

                // Se a chave dos vídeos ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Vídeos']) {
                    dadosProdutos[j]['Vídeos'] = []
                }

                dadosProdutos[j]['Vídeos'].push(videos[i])

                break
            }
        }
    }

    // Imagens
    for (let i = 0; i < imagens.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === imagens[i]['Produto'] && imagens[i]['ProdutoSustentavel']?.toUpperCase() === 'X') {

                // Se a chave das imagens ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Imagens']) {
                    dadosProdutos[j]['Imagens'] = []
                }

                dadosProdutos[j]['Imagens'].push(imagens[i])

                break
            }
        }
    }

    // Notícias
    for (let i = 0; i < noticias.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === noticias[i]['Produto'] && noticias[i]['ProdutoSustentavel']?.toUpperCase() === 'X') {

                // Se a chave das notícias ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Notícias']) {
                    dadosProdutos[j]['Notícias'] = []
                }

                dadosProdutos[j]['Notícias'].push(noticias[i])

                break
            }
        }
    }


    return dadosProdutos
}


async function _buscarDados(idPlanilha, nomeAba) {
    const res = await axios.get(`https://sheets.googleapis.com/v4/spreadsheets/${idPlanilha}/values/${nomeAba}?key=${process.env.REACT_APP_SHEETS_KEY}`)

    const colunas = res.data.values[0]
    const linhas = res.data.values.slice(1, res.data.values.length)

    const objetos = []

    for (let i = 0; i < linhas.length; i++) {
        const objeto = {}

        for (let j = 0; j < linhas[i].length; j++) {
            objeto[colunas[j]] = linhas[i][j]
        }

        objetos.push(objeto)
    }

    return objetos
}

async function _buscarDadosBatch(idPlanilha, nomesAbas) {
    let rangesString = ''

    for (let i = 0; i < nomesAbas.length; i++) {
        rangesString += `&ranges=${nomesAbas[i]}`
    }

    const batchUrl = `https://sheets.googleapis.com/v4/spreadsheets/${idPlanilha}/values:batchGet?key=${process.env.REACT_APP_SHEETS_KEY}${rangesString}`

    const res = await axios.get(batchUrl)

    const ranges = res.data.valueRanges

    const resultado = {}

    for (let i = 0; i < nomesAbas.length; i++) {
        const colunas = ranges[i].values[0]
        const linhas = ranges[i].values.slice(1, ranges[i].values.length)

        const objetos = []

        for (let i = 0; i < linhas.length; i++) {
            const objeto = {}

            for (let j = 0; j < linhas[i].length; j++) {
                objeto[colunas[j]] = linhas[i][j]
            }

            objetos.push(objeto)
        }

        resultado[nomesAbas[i]] = objetos
    }

    return resultado
}

const exports = { buscarDadosEmpresas, buscarDadosProdutos, buscarDadosProdutosSemSeparacaoPorEmpresa }

export default exports
